<script>
  import { orderBy } from 'lodash-es';
  import Department from '../components/Department.svelte';
  import { isReady, departments } from '../data/dataAPI';
  import {
    departmentSorting,
    hoveredDepartmentPage,
    departmentShowIssues,
  } from '../state/uiState';
</script>

<style type="text/scss">
  @import './styles/theme.scss';
  .controls {
    @include fluid-font-size($fs-base);
    @include fluid-space(padding-top, $sp-base);
    text-align: center;
    span {
      color: $c-gray-2;
      @include fluid-space(padding-right, $sp-xxsmall);
    }
    label {
      @include fluid-space(padding-right, $sp-xxsmall);
    }
    label:last-child {
      padding-right: 0;
    }
  }
  .controls__space {
    @include fluid-space(padding-left, $sp-small);
    @include fluid-space(margin-left, $sp-xxxsmall);
    border-left: 1px solid $c-gray-3;
  }
  .departments {
    @include fluid-space(margin-top, $sp-medium);
    @include fluid-space(margin-bottom, $sp-xlarge);
  }
</style>

{#if $isReady}
  <div class="controls">
    <label>
      <span>Anzeigen</span>
      <input type="checkbox" bind:checked={$departmentShowIssues} />
      Ausgabe
    </label>
    <span class="controls__space">Ressorts sortieren nach</span>
    <label>
      <input type="radio" bind:group={$departmentSorting} value={3} />
      Erstansteckung
    </label>
    <label>
      <input type="radio" bind:group={$departmentSorting} value={1} />
      Anzahl infektiöser Seiten
    </label>

  </div>
  <div class="departments">
    {#each $departments as d (d.id)}
      <Department
        id={d.id}
        date={d.firstIssueDate}
        name={d.name}
        pages={d.pages}
        words={d.words}
        sorting={$departmentSorting}
        showSpace={$departmentShowIssues}
        on:mouseover={e => {
          hoveredDepartmentPage.set(e.detail);
        }}
        on:mouseout={d => {
          hoveredDepartmentPage.set(undefined);
        }} />
    {/each}
  </div>
{:else}
  <p>Loading...</p>
{/if}
